<script lang="ts">
  export let src = './aarets-artist.png';
  export let eventName = 'P3-Gull: Årets Artist';
  const width = 350;
</script>

<img {src} alt="Logo for {eventName}" {width} height={width} />

<style>
  img {
    padding: 1rem;
  }
</style>
